import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="ticket"
export default class extends Controller {
  static targets = ["actions", "replyForm", "commentForm", "replyTextArea", "commentTextArea"];
  static classes = ["hidden"];

  connect() {
    // NOTE(James): Using a query selector here because these hidden input elements are generated by form.rich_text_area
    // and we don't seem to have control over its data attributes, only the data attributes of the trix-editor.
    const reply_draft = this.element.querySelector(
      "#our--ticket--reply--content_trix_input_message",
    )?.value;
    const comment_draft = this.element.querySelector(
      "#our--ticket--comment--content_trix_input_message",
    )?.value;
    if (reply_draft) {
      this.hideActions();
      this.showReplyForm();
    } else if (comment_draft) {
      this.hideActions();
      this.showCommentForm();
    }
  }

  show(event) {
    // Check if the clicked element is a link or inside a link
    if (event.target.closest("a")) return;

    // Navigate to the URL specified in the `data-path` attribute of the clicked row
    const path = event.currentTarget.dataset.path;
    if (path) {
      window.location.href = path;
    }
  }

  replyForm(event) {
    event.preventDefault();
    this.hideActions();
    this.showReplyForm();
    this.addContentDecorations();
  }

  addContentDecorations() {
    if (!this.hasReplyTextAreaTarget) return;

    const textArea = this.replyTextAreaTarget;
    const signature = this.replyTextAreaTarget.dataset.signature;
    const footer = this.replyTextAreaTarget.dataset.footer;

    const SIGNATURE_PREFIX = "<br><br>";

    if (textArea.innerHTML.trim() === "" && signature) {
      textArea.innerHTML = `${SIGNATURE_PREFIX}--<br>${signature}`;
    }

    if (footer) {
      textArea.innerHTML += !signature ? SIGNATURE_PREFIX : "<br>";
      textArea.innerHTML += `${footer}`;
    }
  }

  commentForm(event) {
    event.preventDefault();
    this.hideActions();
    this.showCommentForm();
  }

  cancel(event) {
    event.preventDefault();

    this.showActions();

    if (this.hasReplyFormTarget) {
      this.hideReplyForm();
    }

    if (this.hasCommentFormTarget) {
      this.hideCommentForm();
    }
  }

  hideActions() {
    this.actionsTarget.classList.add(this.hiddenClass);
  }

  showActions() {
    this.actionsTarget.classList.remove(this.hiddenClass);
  }

  hideReplyForm() {
    this.replyFormTarget.classList.add(this.hiddenClass);
  }

  showReplyForm() {
    this.replyFormTarget.classList.remove(this.hiddenClass);
  }

  hideCommentForm() {
    this.commentFormTarget.classList.add(this.hiddenClass);
  }

  showCommentForm() {
    this.commentFormTarget.classList.remove(this.hiddenClass);
  }

  resetReplyForm() {
    this.replyFormTarget.reset();
  }

  resetCommentForm() {
    this.commentFormTarget.reset();
  }
}
